import { projectStorage } from '../firebase/config'
import getUser from './getUser'
import { ref } from 'vue'

const { user } = getUser();

const useStorage = () => {
  const error = ref(null);
  const filepath = ref(null);  // 儲存檔案路徑位置
  const url = ref(null);  // 儲存檔案上傳後產生的url
  // uploadFile 非同步上傳檔案，上傳及產生檔案的url
  const uploadFile = async (file) => {
    // 檔案路徑位置：cover > user的id > 傳入的file name
    filepath.value = `cover/${user.value.uid}/${file.name}`;
    // 建立storage的 ref
    const storageRef = projectStorage.ref(filepath.value);
    try {
      const res = await storageRef.put(file);
      url.value = await res.ref.getDownloadURL();
      // 上傳及產生檔案的url
    } catch(err) {
      error.value = err;
    }
  }
  // 刪除對應path中的檔案
  const deleteImag = async (path) => {
    const storageRef = projectStorage.ref(path);
    try {
      await storageRef.delete();
    }catch(err){
      error.value = err.message;
    }
  }

    return { uploadFile, url, error, filepath, deleteImag }
}

export  default useStorage